import {createContext} from 'react';

import {AI_EXTRACTION_BEHAVIOUR} from '../constants/AI_EXTRACTION_BEHAVIOUR';
import {DocumentExtractionBehaviour} from '../types/DocumentExtractionBehaviour';

/** Defaults to AI extraction so components rendered without a provider keep their behaviour. */
export const DocumentExtractionBehaviourContext =
  createContext<DocumentExtractionBehaviour>(AI_EXTRACTION_BEHAVIOUR);
